<template lang="html">
  <footer>
    <section>
      <a v-if="site.instagram.length > 0" :href="'https://instagram.com/' + site.instagram" target="_blank">Instagram. </a>
      <a v-if="site.vimeo.length > 0" :href="site.vimeo" target="_blank">Vimeo. </a>
      <router-link :to="{ name: 'newsletter' }">Newsletter</router-link>
    </section>
  </footer>
</template>

<script>
export default {
  name: 'so-footer',
  computed: {
    site() {
      return this.$store.state.site
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: center;
    padding: 1.5rem;
    section {
        flex: 1 0 auto;
        text-align: center;
    }
}
</style>
